import Color from 'color'

export const colors = {
  // ===== updated palette from confluence page =====
  awaGreen: '#506C24',
  awaGreen75: '#7C915B',
  awaGreen43: '#B4C0A1',
  awaGreen30: '#CBD3BD',
  awaGreen15: '#E5E9DE',
  awaCharcoal: '#3C3B3C',
  awaCharcoal75: '#635E59', // literal value provided by Brad - not calculated
  awaCharcoal50: '#9E9D9E',
  awaCharcoal30: '#C5C4C5',
  awaCharcoal15: '#E2E2E2',
  awaGreyBlue: '#536D73',
  awaGreyBlue75: '#7E9296',
  awaGreyBlue50: '#A9B6B9',
  awaGreyBlue30: '#CBD3D5',
  awaGreyBlue15: '#E5E9EA',
  awaNeutral: '#E2DBD6',
  awaNeutral75: '#E9E4E0',
  awaNeutral50: '#F1EDEB',
  awaNeutral30: '#F6F4F3',
  awaNeutral15: '#FBFAF9',
  awaOrange: '#CB482C',
  awaBlue: '#007AA9',
  awaYellow: '#E4AE3C',
  awaLightGreen: '#A0BD46',
  // ===== older palette =====
  awaBrightBlue: '#007AA9',
  // awaCharcoal: '#3d3a3b',
  // awaGreen: '#4F6C24',
  awaGrey: '#6D6C6D',
  awaGreyGreen: '#E5E9DE',
  // awaLightGrey: '#d8d9da',
  awaLightGrey: '#DFDDDB',
  awaLightBlue: '#A9C8DF',
  awaOffWhite: '#FAF9F9',
  awaTan: '#E2DBD6',
  awaDarkGreen: '#254100',
}

export const opacity = {
  a15: '26',
  a30: '4D',
  a43: '60',
  a50: '80',
  a75: 'BF',
}

const MAX_COLOR_RAMP_POSITIONS = 20
export const colorRamp = [
  // ===== provided by Brad, refer to MM-277 ===== //
  [0.05, '#baabbc'],
  [0.14, '#745778'],
  [0.29, colors.awaBlue], // '#007aa9'
  [0.43, '#d4e3ef'],
  [0.57, colors.awaGreen], // '#4f6c24'
  [0.71, colors.awaLightGreen], // '#a0bc46'
  [0.86, colors.awaYellow], // '#e4ae39'
  [1.00, colors.awaOrange], // '#ca482b'
  [1.01, '#ffffff'],
]

export const interpolateColor = (color1, color2, ratio) => {
  let cappedRatio = Math.max(Math.min(ratio, 1), 0)
  let c1 = Color(color1)
  let c2 = Color(color2)
  let w1 = 1 - cappedRatio
  let w2 = cappedRatio
  return Color.rgb(
    c1.red() * w1 + c2.red() * w2,
    c1.green() * w1 + c2.green() * w2,
    c1.blue() * w1 + c2.blue() * w2
  ).hex()
}

export const generateColors = (number) => {
  if (number === 0) { return [] }

  const numColorVariants = Math.ceil(number / MAX_COLOR_RAMP_POSITIONS)
  const numColors = Math.ceil(number / numColorVariants)

  const emptyArr = new Array(numColors).fill(0)
  const colors = emptyArr
    .map((_, i) => {
      const targetPosition = (i + 1) / numColors
      const firstColorIdx = colorRamp.findLastIndex((rampPosition) => targetPosition >= rampPosition[0])

      const firstColorPos = colorRamp[firstColorIdx][0]
      const firstColor = colorRamp[firstColorIdx][1]
      const secondColorPos = colorRamp[firstColorIdx + 1][0]
      const secondColor = colorRamp[firstColorIdx + 1][1]
      return interpolateColor(
        firstColor,
        secondColor,
        (targetPosition - firstColorPos) / (secondColorPos - firstColorPos)
      )
    })

  // current absolute maximum number of colours is 3*MAX_COLOR_RAMP_POSITIONS
  if (numColorVariants > 1) {
    const lighterColors = colors.map(color => interpolateColor(color, '#ffffff', 0.6))
    colors.push(...lighterColors)
  }
  if (numColorVariants > 2) {
    const darkerColors = colors.map(color => interpolateColor(color, '#000000', 0.6))
    colors.push(...darkerColors)
  }

  return colors.slice(0, number)

}

